export const STORAGE = {
  LOCAL: "local",
  SESSION: "session"
};

export const STORAGE_SPLITTER = "::";

export const KEY_USER = `${STORAGE.LOCAL}::user`;
export const KEY_LANGUAGE = `${STORAGE.LOCAL}::lng`;
export const KEY_LOCATION_SESSION = `${STORAGE.LOCAL}::session_place`;

export const WHITE_THEME = 1;
export const DARK_THEME = 2;